// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9805124f","396":"b78129e2","455":"46f02dbe","977":"9a7c102b"}[chunkId] + ".chunk.js";
};